import { Headers } from '@egw/components'
import { InvestmentsOverviewHoldings } from '@egw/features-holdings'
import { useTranslation } from '@egw/i18n'
import { Layout } from '@egw/layouts'
import { type FC } from 'react'

export const InvestmentsOverviewHoldingsPage: FC = () => {
  const { t } = useTranslation()

  return (
    <Layout>
      <Headers title={t('pages.investment_holdings_overview.title')} />
      <InvestmentsOverviewHoldings />
    </Layout>
  )
}
